import React from 'react';
import { Navigate, Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LayoutDashboard, Newspaper, Image as ImageIcon, MessageSquare, Briefcase, LogOut } from 'lucide-react';

const AdminLayout = () => {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) return <div className="min-h-screen flex items-center justify-center bg-slate-100">Yükleniyor...</div>;
  if (!user || user.role !== 'admin') return <Navigate to="/admin/login" />;

  const menu = [
    { path: '/admin/dashboard', icon: <LayoutDashboard size={20} />, label: 'Dashboard' },
    { path: '/admin/news', icon: <Newspaper size={20} />, label: 'Haberler' },
    { path: '/admin/gallery', icon: <ImageIcon size={20} />, label: 'Galeri' },
    { path: '/admin/contact', icon: <MessageSquare size={20} />, label: 'İletişim Mesajları' },
    { path: '/admin/hr', icon: <Briefcase size={20} />, label: 'İK Başvuruları' },
  ];

  return (
    <div className="flex h-screen bg-slate-50">
      {/* Sidebar */}
      <aside className="w-64 bg-slate-900 text-white flex flex-col">
        <div className="p-6 border-b border-slate-800">
          <h2 className="text-2xl font-bold tracking-tight">İSİLKOOP<span className="text-blue-500">CMS</span></h2>
        </div>
        <nav className="flex-1 p-4 space-y-2">
          {menu.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                location.pathname.startsWith(item.path) 
                  ? 'bg-blue-600 text-white' 
                  : 'text-slate-400 hover:bg-slate-800 hover:text-white'
              }`}
            >
              {item.icon}
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-800">
          <button 
            onClick={logout}
            className="flex items-center gap-3 px-4 py-3 text-slate-400 hover:text-red-400 transition-colors w-full"
          >
            <LogOut size={20} />
            Çıkış Yap
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <header className="bg-white shadow-sm border-b border-slate-200 px-8 py-5 flex justify-between items-center">
          <h1 className="text-xl font-semibold text-slate-800 capitalize">
            {location.pathname.split('/').pop().replace('-', ' ') || 'Dashboard'}
          </h1>
          <div className="flex items-center gap-3">
            <span className="text-sm font-medium text-slate-600">Admin Panel</span>
            <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold">A</div>
          </div>
        </header>
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
